module.exports = __webpack_public_path__ + "static/media/li-hsuan.lung.8831d53e.jpg";